'use client';

import { c as _c } from "react/compiler-runtime";
import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import { useContext } from 'react';
import { AnswerContext } from './Context';
import type { UseAnswerResult } from './types';
function useAnswerContext() {
  const ctx = useContext(AnswerContext);
  if (!ctx) {
    throw new Error("useAnswer must be used within AnswerProvider");
  }
  return ctx;
}
export function useAnswerDispatch() {
  return useAnswerContext().dispatch;
}
export function useAnswer(stepId) {
  const $ = _c(8);
  const {
    store,
    dispatch
  } = useAnswerContext();
  const t0 = store.answers[stepId] as T | undefined;
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== stepId) {
    t1 = next => dispatch({
      type: "SET_ANSWER",
      stepId,
      value: next
    });
    t2 = () => dispatch({
      type: "CLEAR_ANSWER",
      stepId
    });
    $[0] = dispatch;
    $[1] = stepId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      value: t0,
      setAnswer: t1,
      clear: t2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export function useIsAnswerHydrated() {
  return useAnswerContext().store.isHydrated;
}
export function useNotifyAnswerSubmitted() {
  return useAnswerContext().persistSubmittedAnswer;
}
export function useHasSyncedOnLoginRef() {
  return useAnswerContext().hasSyncedOnLoginRef;
}
export function useSubmittedAnswers() {
  return useAnswerContext().store.submittedAnswers;
}
export function useShouldSkipRecommendations() {
  return useAnswerContext().store.shouldSkipRecommendations;
}
export function useResetAnswers() {
  const $ = _c(2);
  const {
    dispatch
  } = useAnswerContext();
  let t0;
  if ($[0] !== dispatch) {
    t0 = () => dispatch({
      type: "RESET_ANSWERS"
    });
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}